import Vue from "vue"
import VueRouter from 'vue-router'

Vue.use(VueRouter)
export default new VueRouter({
	base: process.env.BASE_URL,
	routes:[
		{path: '/', redirect: '/home'},
		{
		  path: '/home',
		  component: resolve => require(['@/views/home'], resolve)
		},
		{
		  path: '/painPoints',
		  component: resolve => require(['@/views/painPoints'], resolve)
		},
		{
		  path: '/solution',
		  component: resolve => require(['@/views/solution'], resolve)
		},
		{
		  path: '/highlights',
		  component: resolve => require(['@/views/highlights'], resolve)
		}, 
		{
		  path: '/componyIntroduce',
		  component: resolve => require(['@/views/componyIntroduce'], resolve)
		}, 
	]
})